import { useState } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import EditProfileModal from "./EditProfileModal";
import { getEntityProfileEditRoute } from "../../../../routers/routeUtils";

interface HeadingActionProps {
  isEntityOwnProfile?: boolean;
  isFollowing: boolean;
  onFollowToggle?: () => void;
}

const HeadingAction = ({ isEntityOwnProfile, isFollowing, onFollowToggle }: HeadingActionProps) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("profiles", { keyPrefix: "header" });
  const navigate = useNavigate();
  const { entityId } = useParams();
  if (isEntityOwnProfile) {
    return (
      <>
        {/* <EditProfileModal open={open} closeModal={() => setOpen(false)} /> */}
        <Button
          variant="primary-sm"
          sx={{
            height: "fit-content",
            marginLeft: "auto",
            width: { xs: "100%", sm: "fit-content" },
          }}
          // onClick={() => setOpen(true)}
          onClick={() => navigate(getEntityProfileEditRoute(entityId!))}
        >
          {t("editProfile")}
        </Button>
      </>
    );
  }

  return (
    <Button
      variant="primary-sm"
      sx={{
        height: "fit-content",
        marginLeft: "auto",
        width: { xs: "100%", sm: "fit-content" },
      }}
      onClick={onFollowToggle}
    >
      {isFollowing ? t("unfollow") : t("follow")}
    </Button>
  );
};

export default HeadingAction;
